/* @flow */

import type {ContactInput} from 'shells/peep-cards/contact-card';

export function contactInputToDisplayOptionEntity(
    input: ContactInput,
    isNew: boolean,
    id?: string
) {
    const result = {
        value: input.name,
        entityDescription: input.description,
        primaryPhoneText: input.phoneNumber,
        primaryEmailText: input.email,
        jobTitle: input.jobTitle,
        isNew: isNew,
        ...(id ? {id} : {}), // This is necessary to satisfy flow and allow for id to be optional
    };

    return result;
}
